import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PropertyDetailFacade } from '../../facades/property-detail.facade';

/**
 * Página de detalle de propiedad (ruta `property/:id`).
 * 100% UI: orquestación y mapeo viven en {@link PropertyDetailFacade}.
 * El facade se provee a nivel de componente (vive con la pantalla).
 */
@Component({
    selector: 'app-property-detail',
    templateUrl: './property-detail.component.html',
    styleUrls: ['./property-detail.component.scss'],
    providers: [PropertyDetailFacade],
})
export class PropertyDetailComponent implements OnInit {

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        readonly facade: PropertyDetailFacade,
    ) {}

    ngOnInit(): void {
        this.reload();
    }

    /** (Re)carga el detalle desde el id de la ruta. También lo usa "Reintentar". */
    reload(): void {
        const propertyId = Number(this.route.snapshot.paramMap.get('id'));
        if (!propertyId) {
            this.router.navigate(['/']);
            return;
        }
        this.facade.load(propertyId);
    }

    share(): void {
        const url = window.location.href;
        const nav = navigator as any;
        if (nav.share) {
            nav.share({ url }).catch(() => this.copyToClipboard(url));
        } else {
            this.copyToClipboard(url);
        }
    }

    private copyToClipboard(text: string): void {
        navigator.clipboard?.writeText(text);
    }

    /** Favoritos: requiere endpoint en el backend (aún no existe). */
    favorite(): void {
        // TODO(backend): endpoint de favoritos/guardados.
    }

    openProperty(propertyId: number): void {
        this.router.navigate(['/property', propertyId]);
    }
}
